import { render, staticRenderFns } from "./BrandProviderCheckList.vue?vue&type=template&id=173149ce&scoped=true"
import script from "./BrandProviderCheckList.vue?vue&type=script&lang=js"
export * from "./BrandProviderCheckList.vue?vue&type=script&lang=js"
import style0 from "./BrandProviderCheckList.vue?vue&type=style&index=0&id=173149ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173149ce",
  null
  
)

export default component.exports